/**
 * @fileoverview Conversión de errores de axios a errores controlados de integración.
 * @module integrations/impl/integration-error
 */

import { NETWORK_ERROR_CODE } from '../models/auth.models'

/**
 * Convierte un error de axios en un error controlado con status, code, message y transactionId.
 * Sin respuesta legible (red, timeout o un 401 de Apigee sin cabeceras CORS) el status es 0.
 * @param {Object} error - Error de axios
 * @returns {import('../models/auth.models').IntegrationError}
 */
export function toIntegrationError (error) {
  const response = error && error.response
  const data = (response && response.data && typeof response.data === 'object') ? response.data : null
  const headers = (response && response.headers) || {}

  const integrationError = new Error((data && (data.error || data.mensajeRespuesta)) || 'Error de integración')
  integrationError.name = 'IntegrationError'
  integrationError.status = response ? response.status : 0
  integrationError.code = (data && data.code) || (response ? `HTTP_${response.status}` : NETWORK_ERROR_CODE)
  integrationError.transactionId = (data && data.transactionId) || headers['transaction-id'] || null
  integrationError.details = (data && data.details) || null
  integrationError.data = data
  return integrationError
}

/**
 * Registra el error con su transactionId (no hay logger centralizado en el front).
 * @param {string} integration - Nombre de la integración
 * @param {string} operation - Operación invocada
 * @param {import('../models/auth.models').IntegrationError} integrationError
 */
export function logIntegrationError (integration, operation, integrationError) {
  console.error(`[${integration}] ${operation} falló: status=${integrationError.status} code=${integrationError.code} transactionId=${integrationError.transactionId || '-'}`)
}



// WEBPACK FOOTER //
// ./src/integrations/impl/integration-error.js